/** Per-device preferences. Kept deliberately small: a driving app should have
 *  almost nothing to configure. */

const KEY = "fanar.settings";

export type Settings = {
  /** 0..1 — applied to the AudioContext gain, so it also works over Bluetooth. */
  volume: number;
  /** Glare mode: heavier strokes and a raised grey floor. Never a polarity change. */
  glare: boolean;
  /** Routing: avoid toll roads (in Albania: Rruga e Kombit, Milot–Morinë). */
  avoidTolls: boolean;
};

const DEFAULTS: Settings = { volume: 0.9, glare: false, avoidTolls: false };

export function loadSettings(): Settings {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw === null) return { ...DEFAULTS };
    const parsed = JSON.parse(raw) as Partial<Settings>;
    return {
      volume: clamp01(typeof parsed.volume === "number" ? parsed.volume : DEFAULTS.volume),
      glare: parsed.glare === true,
      avoidTolls: parsed.avoidTolls === true,
    };
  } catch {
    return { ...DEFAULTS };
  }
}

export function saveSettings(next: Settings): void {
  try { localStorage.setItem(KEY, JSON.stringify(next)); } catch { /* storage blocked */ }
}

export function applyGlare(on: boolean): void {
  document.documentElement.dataset["glare"] = on ? "on" : "off";
}

const clamp01 = (n: number): number => Math.min(1, Math.max(0, n));
